<template>
  <div class="flex h-screen bg-[#FDFDFC] dark:bg-[#0a0a0a] overflow-hidden">
    <!-- Sidebar -->
    <dashboard-sidebar 
      :is-collapsed="sidebarCollapsed"
      :active-menu="activeMenu"
      :app-name="appName"
      :user-permissions="userPermissions"
      @toggle-sidebar="toggleSidebar"
      @change-menu="changeActiveMenu"
    />
    
    <!-- Main Content -->
    <div class="flex-1 flex flex-col overflow-hidden">
      <!-- Navbar -->
      <dashboard-navbar
  ref="navbar"
  :sidebar-collapsed="sidebarCollapsed"
  :user-name="userName"
  :user-role="userRole"
  @toggle-sidebar="toggleSidebar"
  @search="handleNavbarSearch"
  @open-profile="openProfile"
  @open-ticket-by-code="handleOpenTicketByCode"
  @view-all-notifications="handleViewAllNotifications"
/>
      
      <!-- Content avec transmission CORRECTE du ticket sélectionné -->
      <dashboard-content 
        :active-menu="activeMenu"
        :user-roles="userRoles"
        :user-permissions="userPermissions"
        :user-name="userName"
        :search-query="searchQuery"
        :user-data="currentUser"
        :selected-ticket-code="selectedTicketCode"
        :key="contentKey"
        @update-search="updateSearchQuery"
        @ticket-selected="handleTicketSelected"
        @profile-updated="handleProfileUpdated"
        @clear-ticket-filter="handleClearTicketFilter"
      />
      
    </div>
  </div>
</template>

<script>
import DashboardNavbar from './DashboardNavbar.vue';
import DashboardSidebar from './DashboardSidebar.vue';
import DashboardContent from './DashboardContent.vue';

export default {
  name: 'Dashboard',
  components: {
    DashboardNavbar,
    DashboardSidebar,
    DashboardContent
  },
  props: {
    userName: {
      type: String,
      required: true
    },
    appName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      sidebarCollapsed: false,
      activeMenu: 'dashboard',
      userRoles: [],
      userPermissions: [],
      userRole: '',
      searchQuery: '',
      selectedTicket: null,
      currentUser: {},
      selectedTicketCode: '', // ✅ Initialisé
      contentKey: 0,
      navigationInProgress: false
    };
  },
  mounted() {
  if (window.Laravel && window.Laravel.userData) {
    this.userRoles = window.Laravel.userData.roles || [];
    this.userPermissions = window.Laravel.userData.permissions || [];
    this.userRole = this.userRoles[0] || 'Utilisateur';
    this.currentUser = window.Laravel.userData;

    // ✅ Forcer le chargement des notifications après un court délai
    setTimeout(() => {
      this.forceLoadNotifications();
    }, 50);
  }
},
  methods: {
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed;
    },
    forceLoadNotifications() {
    if (this.$refs.navbar && this.$refs.navbar.canSeeNotifications) {
      this.$refs.navbar.loadNotifications();
    }
  },
    
    // Dans Dashboard.vue - methods
handleNavbarSearch(searchData) {
  // CORRECTION : Gérer correctement l'objet searchData
  if (typeof searchData === 'object' && searchData.query !== undefined) {
    this.searchQuery = searchData.query;
  } else if (typeof searchData === 'string') {
    this.searchQuery = searchData;
  } else {
    this.searchQuery = '';
  }
  
  if (this.activeMenu !== 'tickets' && this.searchQuery.trim()) {
    this.activeMenu = 'tickets';
  }
},
    
    openProfile() {
      this.activeMenu = 'profile';
    },
    
    handleViewAllNotifications() {
      this.activeMenu = 'tickets';
    },
    
    updateSearchQuery(query) {
      this.searchQuery = query;
    },
    
    handleTicketSelected(ticket) {
      this.selectedTicket = ticket;
    },

    handleProfileUpdated(updatedUser) {
      this.currentUser = { ...this.currentUser, ...updatedUser };
      if (updatedUser.name) {
        this.userName = updatedUser.name;
      }
    },

    // ✅ CORRECTION : Navigation avec gestion d'état
    // Dans Dashboard.vue - methods
handleOpenTicketByCode(ticketCode) {
  
  if (this.navigationInProgress) {
    return;
  }
  
  this.navigationInProgress = true;
  
  // 1. Définir le ticket code dans la recherche globale
  this.searchQuery = ticketCode;
  
  // 2. Naviguer vers tickets
  if (this.activeMenu !== 'tickets') {
    this.activeMenu = 'tickets';
  }
  
  // 3. Réinitialiser le selectedTicketCode (on utilise maintenant searchQuery)
  this.selectedTicketCode = '';
  
  // 4. Forcer le re-rendering
  this.$nextTick(() => {
    this.contentKey++;
    
    setTimeout(() => {
      this.navigationInProgress = false;
    }, 200);
  });
},

    changeActiveMenu(menu) {
      this.activeMenu = menu;
      this.searchQuery = '';
      
      // ✅ Réinitialiser le ticket code seulement si on quitte la page tickets
      if (menu !== 'tickets') {
        this.selectedTicketCode = '';
      }
      
      this.contentKey++;
    },

    handleClearTicketFilter() {
      this.selectedTicketCode = '';
      this.contentKey++;
      this.$nextTick(() => {
      });
    }
  },
  
  watch: {
    activeMenu(newMenu, oldMenu) {
      if (newMenu !== 'tickets') {
        this.selectedTicketCode = '';
      }
    },
    
    selectedTicketCode(newCode, oldCode) {
    },
    
    contentKey(newKey) {
    }
  }
};
</script>